const config = {
  locale:
    window.localStorage && window.localStorage.getItem
      ? window.localStorage.getItem("locale")
      : "en",
  IS_CONSOLE_ALLOWED: true,
  API_URL: "https://api.3dprintit.net/s/api/v1",
  WEBSITE_URL: "https://techdurbar.com",
  // GRAPHQL_ENDPOINT: "https://api.3dmake.org/graphql",
  GRAPHQL_ENDPOINT: "https://api-3dmake.up.railway.app/graphql",
  // GRAPHQL_SUBSCRIPTION_ENDPOINT: "wss://api.3dmake.org/subscriptions",
  GRAPHQL_SUBSCRIPTION_ENDPOINT: "wss://api-3dmake.up.railway.app/subscriptions",
  BASE_URL: "https://3dmake.org",
};
if (process.env.NODE_ENV === "production") {
  config.IS_CONSOLE_ALLOWED = false;
  //   config.GRAPHQL_ENDPOINT = "";
  //   config.GRAPHQL_SUBSCRIPTION_ENDPOINT = "";
}
if (process.env.REACT_APP_SERVER_TEST) {
  config.GRAPHQL_ENDPOINT = "http://localhost:5000/graphql";
  config.GRAPHQL_SUBSCRIPTION_ENDPOINT = "ws://localhost:5000/subscriptions";
  config.API_URL = "http://localhost:5000/s/api/v1";
}
export default config;
